module.exports = __webpack_public_path__ + "img/logo.f83dbae1.png";